import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { SharedUiStampModule } from '@fantaz/shared/ui/stamp';
import { CardComponent } from './card.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedPipesDateModule,
    SharedUiStampModule,
  ],
  declarations: [CardComponent],
  exports: [CardComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedUiCardModule {}
